module.exports = __webpack_public_path__ + "img/NymbleUp Store Setting Section.64a564dd.png";